module.exports = __webpack_public_path__ + "assets/img/BnBerry-Landing-Page-+-Website.3dd8bad2.webp";